import componentTypesDataForms from '@data-driven-forms/react-form-renderer/dist/cjs/component-types';
import assign from "lodash/assign";
export var componentTypes = assign({}, componentTypesDataForms, {
    COURSE_META: 'course-meta',
    PRICE_BREAKUP: 'price-breakup',
    ACCORDION: "ws-accordion",
    ACCORDION_ITEM: "ws-accordion-item",
    PRICE_SELECT: "ws-price-select",
    PAYMENT_GATEWAY: "ws-payment-gateway",
    PAYMENT_GATEWAY_RADIO: "ws-payment-gateway-radio",
    FORM_BUTTONS: "ws-form-buttons",
    FIELD_SET: "ws-fieldset",
    CART_TABLE: "ws-cart-table",
    CART_TABLE_ROW_ITEM: "ws-cart-row",
    SEARCH_N_SELECT: "ws-search-select",
    CARD: "ws-card",
    BASIC: "ws-basic",
    MENU: "ws-menu",
    MENU_ITEM: "ws-menu-item",
    TIME_SLOT: "ws-time-slot",
    COUPON_CODE: "ws-coupon-code",
});
